import { useQuery } from '@tanstack/react-query';
import { getSubdomain, isValidSubdomain } from '@zealy/utils';
import { tiktokCampaignKeys } from '../tiktokCampaign.keys';
import { isUserRegisteredToTiktokCampaign } from '../tiktokCampaign.service';
/**
 * Check if the current user is registered to a TikTok campaign
 * @param tiktokCampaignId The ID of the TikTok campaign
 * @param subdomain The subdomain of the community to query, @default subdomain will be inferred from the URL
 * @param enabled Whether the query should be enabled
 * @example const { data: isRegistered, isLoading } = useIsUserRegistered('campaign-id');
 */
export const useIsUserRegisteredToTiktokCampaign = (tiktokCampaignId, subdomain, enabled = true) => {
    const domain = subdomain || getSubdomain();
    return useQuery({
        queryKey: tiktokCampaignKeys.isUserRegistered(domain, tiktokCampaignId),
        queryFn: async () => isUserRegisteredToTiktokCampaign(domain, tiktokCampaignId),
        enabled: isValidSubdomain(domain) && !!tiktokCampaignId && enabled,
        retry: 1,
    });
};
